<template>
  {{ (new Date(props.item[props.column.key])).toLocaleString() }}
</template>

<script setup>
  
const props = defineProps({
  item: Object,
  column: Object
});

</script>